














































import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetAssayGroup, GetAssays, SaveAssayGroup} from "@/api/assay"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	loading = false
	editShow = false
	model:any = {
		groupName: '',
		item: '',
		items: []
	}
	items:any = []
	columns = [
		{
			title: '时间',
			key: 'date'
		},
		{
			title: '检验组套名称',
			key: 'groupName'
		},
		{
			title: '操作',
			width: 100,
			render: (h:any, p:any) => {
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						on:{
							click:()=>{
								this.edit(p)
							}
						}
					},'编辑')
				])
			}
		}
	]
	columns1 = [
		{
			title: '项目名称',
			key: 'itemName'
		},
		{
			title: '最小值',
			key: 'minValue'
		},
		{
			title: '最大值',
			key: 'maxValue'
		},
		{
			title: '操作',
			width: 100,
			render: (h:any, p:any) => {
				return h('div', [
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.deleteOne(p)
							}
						}
					},'删除')
				])
			}
		}
	]
	dialogTitle = ' '
	data = []
	private query = ''
	addOne(){
		this.model = {
			groupName: '',
			item: '',
			items: []
		}
		this.editShow = true
	}
	created() {
		this.getSelects()
		this.getData()
	}
	async save() {
		if (!this.model.groupName) {
			this.$Message.error('清输入化验单名称！')
			return
		}
		let res = await SaveAssayGroup(this.model)
		if (res.status === 1) {
			this.editShow = false
		}
	}
	visibleChange(value:boolean){
		if(!value){
			this.editShow = false
			this.getData()
		}
	}
	deleteOne(p:any){
		this.model.items.splice(p.add,1)
	}
	add(){
		if (this.model.item.id) {
			let contain = false
			this.model.items.forEach((item: any) => {
				if (this.model.item.id === item.assayId) {
					contain = true
				}
			})
			if (!contain) {
				this.model.items.push({assayId:this.model.item.id,...this.model.item})
			} else {
				this.$Message.info('当前详情中已存在')
			}
			this.model.item = ''
		} else {
			this.$Message.error('清选择单项！')
		}

	}
	private async getData() {
		this.loading = true
		let res = await GetAssayGroup({QueryString: this.query})
		this.data = res.objects
		this.loading = false
	}
	async getSelects(){
		let res = await GetAssays({})
		this.items = res.objects
	}

	private edit(p: any) {
		this.model = p.row
		this.editShow = true
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayPackage/index.vue